import { useSyncExternalStore } from "react";
function subscribe(_c: () => void) {
  return () => {};
}
function getSnapshot() {
  return true;
}
function getServerSnapshot() {
  return false;
}
export function useIsClient() {
  const isMounted = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return isMounted;
}